import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

interface Props {
  title: string
  list: StrapiBlockComponent[]
}

function GearingUp({ title, list }: Props) {
  return (
    <section id="gearing-up" className="bg-[#090909] text-white relative">
      <Image
        src="/assets/index-25/decode-bg-img.png"
        alt="decode-bg-img"
        height="955"
        width="1441"
        className="absolute w-full h-full object-top"
      />
      <div className="container | relative z-10 mx-auto py-10 md:py-18">
        <div className="mb-14 md:mb-24 md:max-w-col-9">
          <h1 className="title text-4xl md:text-5xl font-medium tracking-tight">
            {title}
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-20 justify-center items-start">
          {list.map(ele => (
            <div key={ele.id}>
              <Image
                src={ele.multimedia?.media?.data?.attributes.url ?? ''}
                alt={
                  ele.multimedia?.media?.data?.attributes.alternativeText ?? ''
                }
                width={ele.multimedia?.media?.data?.attributes.width}
                height={ele.multimedia?.media?.data?.attributes.height}
                className="object-cover w-full mb-6"
              />
              <h3
                className="text-2xl font-semibold mb-5"
                dangerouslySetInnerHTML={{ __html: ele.title ?? '' }}
              />
              <div
                className="text-lg text-gray-40 inline-block mb-6"
                dangerouslySetInnerHTML={{
                  __html: ele.description ?? ''
                }}
              />
              <div className="flex flex-col md:flex-row">
                <Link
                  href={ele.link?.href ?? ''}
                  target={ele.link?.target}
                  className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] whitespace-nowrap text-sm text-center font-medium rounded-lg py-2 px-10 w-full md:w-auto"
                >
                  {ele.link?.title}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GearingUp
